import React from "react";
import { uepClient } from "uepClient";
import { connect } from "react-redux";
import Select from "react-select";
import { getUsername } from "../../utils/Common";
import "./Agentstatus.scss";
import { UserStatus } from "constants/UserConstants";
import { changeUserStatus } from "actions/userActions";
import { withRouter } from "react-router-dom";
import dayjs from "utils/dayjs";
import WithAlert from "hoc/WithAlert";

const options = [
  { value: UserStatus.NOT_READY, label: "Not Ready" },
  { value: UserStatus.READY, label: "Ready" },
  { value: UserStatus.BIOBREAK, label: "Bio-break" },
  { value: UserStatus.LUNCHBREAK, label: "Lunch Break" },
  { value: UserStatus.TRAINING, label: "Training" },
];

const customStyles = {
  control: (provided) => ({
    ...provided,
    width: 120,
    minWidth: 120,
    height: 34,
    minHeight: 34,
    font: "normal normal bold 14px/19px Roboto",
    background: "none",
    paddingLeft: "0px",
    backgroundColor: "white",
    boxShadow: "0px 3px 6px #00000012",
    border: "none",
  }),
  option: (provided, { isSelected, isFocused }) => ({
    ...provided,
    width: 120,
    minWidth: 120,
    height: 34,
    minHeight: 34,
    letterSpacing: "0px",
    color: isSelected ? "#39C379" : "#838EAB",
    font: isFocused
      ? "normal normal bold 14px/19px Roboto"
      : "normal normal normal 14px/19px Roboto",
    backgroundColor: isSelected || isFocused ? "#E6EBF1" : "white",
    border: "none",
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    width: 28,
    paddingTop: 0,
    paddingBottom: 0,
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : null,
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#39C379",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 100,
  }),
};

class Agentstatus extends React.Component {
  constructor(props) {
    super(props);
    this.state = { selectedOption: options[0] };
    this.handleAgentStatusChange = this.handleAgentStatusChange.bind(this);
    this.props = props;
  }

  componentDidMount() {
    this.getUserStatusAndUpdate();
  }

  getUserStatusAndUpdate() {
    const username = getUsername();
    let optionToSelect = options[0]; //NOT READY status by Default.
    uepClient()
      .get(`/agent/activity/${username}`)
      .then((response) => {
        const latestStatus = response.data.agentStatus;
        if (
          latestStatus !== UserStatus.LOGIN &&
          latestStatus !== UserStatus.LOGOUT
        ) {
          optionToSelect = options.find(
            (option) => option.value === latestStatus
          );
          this.setState({ selectedOption: optionToSelect });
          this.props.changeUserStatus(
            latestStatus,
            response.data.eventDateTime
          );
        } else {
          this.setState({ selectedOption: optionToSelect });
          this.props.changeUserStatus(
            latestStatus,
            response.data.eventDateTime
          );
        }
      })
      .catch((error) => {
        console.error(
          "Some error occured while trying to fetch latest activity",
          error.message
        );
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Some error occured while trying to fetch latest
              activity.
            </span>
          ),
        });
        this.setState({ selectedOption: optionToSelect });
      });
  }

  handleAgentStatusChange(newSelectedOption) {
    var currentDateTime = dayjs.utc();
    this.recordUserActivity(newSelectedOption.value);
    this.props.changeUserStatus(newSelectedOption.value, currentDateTime);
    this.setState({ selectedOption: newSelectedOption });
  }

  recordUserActivity(status) {
    uepClient()
      .post(`/agent/activity`, {
        username: this.props.username,
        status: status,
      })
      .then(() => {
        console.info(`Successfully updated agent activity to ${status}`);
      })
      .catch((error) => {
        this.props.showAlert({
          variant: "danger",
          content: (
            <span>
              <b>Error!</b> Failed to update the agent status, Please try again.
            </span>
          ),
        });
        console.error(
          `Some error occured while trying to update agent status to ${status}`,
          error.message
        );
      });
  }

  render() {
    const { selectedOption } = this.state;
    return (
      <Select
        defaultValue={selectedOption}
        onChange={this.handleAgentStatusChange}
        options={options}
        styles={customStyles}
        value={selectedOption}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  agentStatus: state.user.status,
});

const mapDispatchToProps = {
  changeUserStatus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(WithAlert(Agentstatus)));
